import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseCR = props => <ServerComponentCaller url={"assets/data/pages/licencias/CR.json"}/>;

export default LicenciaClaseCR;
